
import useAppStorage from './app-storage.js'

export default function useUser() {

    const { store, clear } = useAppStorage();

    function responseAfterLogin(res){
        const access_token = res.data.access_token
        const username = res.data.user.name
        store(access_token,username)
    }

    function hasToken(){
         const storeToken = localStorage.getItem('token');
         if (storeToken) {
             return true
         }
         return false;
    }

    function getToken(){
        const storeToken = localStorage.getItem('token');
        if (storeToken) {
            return storeToken;
        }
        return false;
    }

    function loggedIn(){
         return hasToken();
    }

    function name(){
         if (loggedIn()) {
             return localStorage.getItem('user');
         }
     }

    function clearToken(){
        clear();
    }

    return {
        responseAfterLogin,
        hasToken,
        getToken,
        loggedIn,
        name,
        clearToken
    }

}
